// Copyright (c) 2025 Audere, All Rights Reserved

import { useCallback } from "react";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { theme } from "../../theme";
import type { BottomBasketContentProps } from "../types/projects";
import { createStyleSheet } from "../utils/styles";
import { useTranslation } from "react-i18next";

const BottomBasketContent = (props: BottomBasketContentProps) => {
  const { t } = useTranslation("BottomBasketContent");
  const { testsCount, onContinueClick, onClick, isOpen, onCancel } = props;

  const handleBasketClick = useCallback(() => {
    if (!isOpen) {
      onClick();
    }
  }, [isOpen, onClick]);
  return (
    <Box
      sx={{
        ...styles.basketContainer,
        cursor: isOpen ? "pointer" : "default",
      }}
      onClick={handleBasketClick}
    >
      <Stack flexDirection="row" justifyContent="start" alignItems="center" flexGrow={1} gap={1}>
        <ShoppingCartIcon />
        <Typography variant="h6">{`${testsCount} ${t("testsSelected")}`}</Typography>
        <IconButton onClick={onClick}>
          {isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Stack>

      <Button variant="outlined" onClick={onCancel} sx={styles.cancelBtn}>
        {t("common:cancel")}
      </Button>
      <Button variant="contained" disabled={!testsCount} onClick={onContinueClick}>
        {t("continue")}
      </Button>
    </Box>
  );
};

export default BottomBasketContent;

const styles = createStyleSheet({
  basketContainer: {
    display: "flex",
    alignItems: "center",
    p: 3,
    border: `1px solid ${theme.palette.grey[300]}`,
    bgcolor: "background.paper",
  },
  cancelBtn: { mr: 2 },
});
